import Accordion from '@/scripts/optional/accordion'

export default function SpecificationAccordion() {
	const mainEl = document.querySelector('.product-specific-accordion');
	mainEl && new Accordion({
		el: '.product-specific-accordion',
		trigger: '.accordion-el__head',
		showOne: true
	})
}